export default "__VITE_ASSET__DdX82yKC__"